window.addEventListener('scroll', () => {
    document.body.classList.toggle('scrolled', window.scrollY > 0);
}, { passive: true });

document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('mobile-header');
    const trigger = document.getElementById('mobile-menu-trigger');
    const headerIcons = document.getElementById('header-icons');
    const menuContent = document.getElementById('menu-content');
    const menuMain = document.getElementById('menu-main');
    const headerMenuTitle = document.getElementById('header-menu-title');
    const menuActions = document.getElementById('menu-actions');

    const searchInputContainer = document.getElementById('search-input-container');
    const mobileSearchInput = document.getElementById('mobile-search-input');
    const headerLogo = document.getElementById('header-logo');
    const searchTrigger = document.getElementById('search-trigger');

    if (!header || !trigger || !menuContent) return;

    let isMenuOpen = false;
    let activeSubmenu = null;
    let menuOpenScrollY = 0;

    let initialHeaderWidth = null;
    let targetHeaderWidth = null;
    let currentHeaderWidth = null;
    let menuResizeObserver = null;

    function setHeaderWidth(px) {
        if (currentHeaderWidth === px) return;
        currentHeaderWidth = px;
        requestAnimationFrame(() => {
            header.style.width = `${px}px`;
        });
    }

    function hideSearchShowLogo() {
        if (searchInputContainer) {
            searchInputContainer.style.opacity = '0';
            searchInputContainer.style.pointerEvents = 'none';
            searchInputContainer.style.width = '0';
        }

        if (mobileSearchInput) {
            mobileSearchInput.style.height = '32px';
            mobileSearchInput.style.borderRadius = '80px';
        }

        if (headerLogo) {
            headerLogo.style.opacity = '1';
            headerLogo.style.transform = 'scale(1)';
        }

        if (!searchTrigger) {
            return;
        }
        searchTrigger.style.opacity = '1';
        searchTrigger.style.transform = 'none';
        searchTrigger.style.zIndex = 'auto';
    }

    function toggleMenu() {
        if (isMenuOpen) {
            closeMenu();
        } else {
            openMenu();
        }
        isMenuOpen = !isMenuOpen;
    }

    function openMenu() {
        const parentWidth = header.parentElement.clientWidth;
        let menuHeight = 0;

        document.body.classList.add('!overflow-hidden');

        if (initialHeaderWidth === null) {
            initialHeaderWidth = header.offsetWidth;
            targetHeaderWidth = Math.round(parentWidth * 0.5);
        }

        hideSearchShowLogo();

        menuHeight = menuMain.scrollHeight;
        const actionsHeight = menuActions ? menuActions.scrollHeight : 0;

        const headerTop = header.getBoundingClientRect().top;
        const headerAvailableHeight = Math.max(0, window.innerHeight - headerTop);

        requestAnimationFrame(() => {
            header.classList.add('menu-open');
            if (initialHeaderWidth !== null && !header.style.width) {
                header.style.width = `${initialHeaderWidth}px`;
            }
            setHeaderWidth(targetHeaderWidth);

            header.style.maxHeight = `${headerAvailableHeight}px`;
            header.classList.remove('overflow-hidden');
            header.classList.add('overflow-y-auto');

            headerIcons.style.opacity = '0';
            headerIcons.style.width = '0';
            headerIcons.style.transform = 'scale(0.8)';

            menuContent.style.maxHeight = `${menuHeight}px`;
            menuContent.style.opacity = '1';
            menuContent.style.pointerEvents = 'auto';
            menuContent.classList.remove('overflow-y-auto');
            menuContent.classList.add('overflow-hidden');

            if (typeof ResizeObserver !== 'undefined') {
                menuResizeObserver?.disconnect();
                menuResizeObserver = new ResizeObserver(() => {
                    const next = menuMain.scrollHeight;
                    if (next > 0 && `${next}px` !== menuContent.style.maxHeight) {
                        menuContent.style.maxHeight = `${next}px`;
                    }
                });
                menuResizeObserver.observe(menuMain);
            }

            if (menuActions) {
                menuActions.style.maxHeight = `${actionsHeight}px`;
                menuActions.style.opacity = '1';
                menuActions.style.pointerEvents = 'auto';
            }

            const headerDefault = document.getElementById('header-default');
            const timeBasedThemeEnabled = header?.dataset.timeBasedThemeEnabled === 'true';
            if (!timeBasedThemeEnabled) {
                if (headerDefault) {
                    headerDefault.classList.remove('bg-[#000000B2]');
                    headerDefault.classList.add('bg-black');
                }
                if (menuContent) {
                    menuContent.classList.remove('bg-[#000000B2]');
                    menuContent.classList.add('bg-black');
                }
            }
        });
    }

    function closeMenu() {
        if (activeSubmenu) closeSubmenu(activeSubmenu);

        menuResizeObserver?.disconnect();
        menuResizeObserver = null;

        document.body.classList.remove('!overflow-hidden');

        requestAnimationFrame(() => {
            header.classList.remove('menu-open');

            header.style.maxHeight = '';
            header.classList.remove('overflow-y-auto');
            header.classList.add('overflow-hidden');
            header.scrollTop = 0;

            menuContent.style.maxHeight = '0';
            menuContent.style.opacity = '0';
            menuContent.style.pointerEvents = 'none';
            menuContent.classList.remove('overflow-y-auto');
            menuContent.classList.add('overflow-hidden');

            setHeaderWidth(initialHeaderWidth);

            headerIcons.style.opacity = '1';
            headerIcons.style.width = 'auto';
            headerIcons.style.transform = 'scale(1)';

            if (headerMenuTitle) {
                const textSpan = headerMenuTitle.querySelector('.menu-title-text');
                if (textSpan) {
                    textSpan.textContent = '';
                    textSpan.classList.add('hidden');
                }
                headerMenuTitle.classList.remove('opacity-100', 'pointer-events-auto', 'max-w-[200px]');
                headerMenuTitle.classList.add('opacity-0', 'pointer-events-none', 'max-w-0');
            }

            if (menuActions) {
                menuActions.style.maxHeight = '0';
                menuActions.style.opacity = '0';
                menuActions.style.pointerEvents = 'none';
            }

            const headerDefault = document.getElementById('header-default');
            const timeBasedThemeEnabled = header?.dataset.timeBasedThemeEnabled === 'true';
            if (!timeBasedThemeEnabled) {
                if (headerDefault) {
                    headerDefault.classList.remove('bg-black');
                    headerDefault.classList.add('bg-[#000000B2]');
                }
                if (menuContent) {
                    menuContent.classList.remove('bg-black');
                    menuContent.classList.add('bg-[#000000B2]');
                }
            }
        });
    }

    function openSubmenu(index, linkTitle) {
        const submenu = document.getElementById(`submenu-${index}`);
        if (!submenu) return;

        activeSubmenu = index;

        const parentWidth = header.parentElement.clientWidth;

        requestAnimationFrame(() => {
            setHeaderWidth(parentWidth * 0.85);

            if (headerMenuTitle) {
                const textSpan = headerMenuTitle.querySelector('.menu-title-text');
                if (textSpan) {
                    textSpan.textContent = linkTitle;
                    textSpan.classList.remove('hidden');
                }
                headerMenuTitle.classList.remove('opacity-0', 'pointer-events-none', 'max-w-0');
                headerMenuTitle.classList.add('opacity-100', 'pointer-events-auto', 'max-w-[200px]');
            }

            menuMain.classList.add('fade-out');
        });

        setTimeout(() => {
            requestAnimationFrame(() => {
                menuMain.style.display = 'none';

                submenu.style.opacity = '0';
                submenu.style.transform = 'scale(0.98)';
                submenu.classList.add('active');

                menuContent.style.maxHeight = "55vh";
                menuContent.classList.remove('overflow-hidden');
                menuContent.classList.add('overflow-y-auto');

                void submenu.offsetHeight;

                requestAnimationFrame(() => {
                    submenu.style.opacity = '1';
                    submenu.style.transform = 'scale(1)';
                });
            });
        }, 175);
    }

    function closeSubmenu(index) {
        const submenu = document.getElementById(`submenu-${index}`);
        if (!submenu) return;

        requestAnimationFrame(() => {
            submenu.style.opacity = '0';
            submenu.style.transform = 'scale(0.98)';

            setHeaderWidth(targetHeaderWidth);

            if (!headerMenuTitle) {
                return;
            }
            const textSpan = headerMenuTitle.querySelector('.menu-title-text');
            if (textSpan) {
                textSpan.textContent = '';
                textSpan.classList.add('hidden');
            }
            headerMenuTitle.classList.remove('opacity-100', 'pointer-events-auto', 'max-w-[200px]');
            headerMenuTitle.classList.add('opacity-0', 'pointer-events-none', 'max-w-0');
        });

        setTimeout(() => {
            requestAnimationFrame(() => {
                submenu.classList.remove('active');

                menuMain.style.display = 'flex';
                menuMain.style.opacity = '0';
                menuMain.style.transform = 'scale(0.98)';
                menuMain.classList.remove('fade-out');

                void menuMain.offsetHeight;

                const menuHeight = menuMain.scrollHeight;

                menuContent.style.maxHeight = `${menuHeight}px`;
                menuContent.classList.remove('overflow-y-auto');
                menuContent.classList.add('overflow-hidden');

                requestAnimationFrame(() => {
                    menuMain.style.opacity = '1';
                    menuMain.style.transform = 'scale(1)';
                });
            });
        }, 175);

        activeSubmenu = null;
    }

    /* ---------- Events ---------- */
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        toggleMenu();
    });

    menuContent.addEventListener('click', (e) => {
        const submenuLink = e.target.closest('[data-has-submenu="true"]');
        const backButton = e.target.closest('.submenu-back');

        if (submenuLink) {
            e.preventDefault();
            const linkTitle = submenuLink.dataset.linkTitle || '';
            openSubmenu(submenuLink.dataset.linkIndex, linkTitle);
        }

        if (backButton) {
            e.preventDefault();
            closeSubmenu(backButton.dataset.submenuIndex);
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMenuOpen) toggleMenu();
    });

    /* ---------- Header visibility on footer scroll ---------- */
    const headerParent = document.querySelector('header');
    const footer = document.querySelector('.footer-section, .footer');

    if (headerParent && footer) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        headerParent.classList.add('opacity-0', 'pointer-events-none');
                    } else {
                        headerParent.classList.remove('opacity-0', 'pointer-events-none');
                    }
                });
            },
            {
                threshold: 0.3,
            }
        );

        observer.observe(footer);
    }

    const mainHeader = document.getElementById('main-header');
    const announcementBar = document.getElementById('announcement-bar');
    const saleTimerEl = document.querySelector('.sale-timer-section');
    const topBarReference = announcementBar || saleTimerEl;

    if (!(mainHeader && topBarReference)) {
        return;
    }
    const MOBILE_BREAKPOINT = 1024;
    let isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    function updateHeaderPosition(isTopBarVisible) {
        if (isMobile) {
            document.body.classList.toggle('announcement-bar-hidden', !isTopBarVisible);
        } else {
            document.body.classList.remove('announcement-bar-hidden');
        }
    }

    const announcementObserver = new IntersectionObserver(
        (entries) => {
            const scheduleUpdate = window.requestIdleCallback || requestAnimationFrame;
            scheduleUpdate(() => {
                entries.forEach((entry) => {
                    if (isMobile) {
                        updateHeaderPosition(entry.isIntersecting);
                    }
                });
            });
        },
        {
            threshold: 0,
            rootMargin: '0px',
        }
    );

    announcementObserver.observe(topBarReference);

    function resolveTopBarVisible() {
        if (!announcementBar) {
            // Sale timer only — compact as soon as user scrolls at all
            return (window.scrollY || window.pageYOffset) === 0;
        }
        const rect = topBarReference.getBoundingClientRect();
        return rect.bottom > 0;
    }

    let scrollTicking = false;
    function checkHeaderPositionOnScroll() {
        if (!isMobile) {
            scrollTicking = false;
            return;
        }

        const scrollY = window.scrollY || window.pageYOffset;

        if (!announcementBar || scrollY <= 20) {
            updateHeaderPosition(resolveTopBarVisible());
        }

        scrollTicking = false;
    }

    window.addEventListener('scroll', () => {
        if (!scrollTicking) {
            window.requestAnimationFrame(checkHeaderPositionOnScroll);
            scrollTicking = true;
        }
    }, { passive: true });

    let resizeTimeout;
    let rafId = null;

    function handleResize() {
        clearTimeout(resizeTimeout);
        cancelAnimationFrame(rafId);

        resizeTimeout = setTimeout(() => {
            const wasMobile = isMobile;
            isMobile = window.innerWidth < MOBILE_BREAKPOINT;

            if (wasMobile !== isMobile || isMobile) {
                rafId = requestAnimationFrame(() => {
                    updateHeaderPosition(resolveTopBarVisible());
                });
            }
        }, 150);
    }

    window.addEventListener('resize', handleResize, { passive: true });

    requestAnimationFrame(() => {
        updateHeaderPosition(resolveTopBarVisible());
    });
});
